import { OrganizationApi, ToastStateHandler } from '../../../api';
import { SendInviteEmailsBody } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostSendEmails = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (organizationId: string, body: SendInviteEmailsBody) => {
        const { exec, clearCache, abort } = organizationApi.sendInviteEmails({
            params: { organizationId },
            body: body,
            onSuccess: _ => {
                toastHandler.push('success', t('organization.inviteMembersTitle'), t('organization.inviteMembersMessage_Success'));
                clearCache();
            },
            onError: _ => toastHandler.push('error', t('organization.inviteMembersTitle'), t('organization.inviteMembersMessage_Failed')),
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpPostSendEmails;
